import React, {useEffect, useState} from "react";
import "./Game.sass";
import {blue, colors, green, red} from "../../../../common/colors";
import {useSelector} from "react-redux";
import {ADDRESS} from "../../../../_api/client";
import {PHASE_ANSWER, PHASE_EXERCISE, PHASE_PREPARE, PHASE_RESULT} from "./phases";
import PropTypes from "prop-types";
import {useNavigate} from "react-router";
import {getNameByValue, solveTypes} from "../../../../common/themes";
import {ORDINARY, TURBO_PLUS} from "../../../../common/taskTypes";

export default function Game({phase, setPhase, myAnswer, taskType}) {

    const prepare = [3, 2, 1, "Старт!"];
    let prepareIndex = 0;

    const [currentValue, setCurrentValue] = useState();
    const [intervalIdPrepare, setIntervalIdPrepare] = useState(0);
    const [timeoutId, setTimeoutId] = useState(0);
    const [color, setColor] = useState(blue)

    const {data: task} = useSelector(state => state.game.task)
    const {data: answer} = useSelector(state => state.game.answer)

    const navigate = useNavigate();

    const voice = (value) => {
        let audio = new Audio(ADDRESS + "/numb/" + value + ".mp3")
        audio.playbackRate = 1.5
        audio.play()
    }

    const createInterval = (items, nextPhase, speed, voice1) => {
        const interval = setInterval(() => {
            if (prepareIndex === items.length) {
                if (nextPhase === PHASE_EXERCISE) {
                    voice("start");
                }
                clearInterval(interval);
                prepareIndex = 0;
                setPhase(nextPhase);
                return;
            }

            setCurrentValue(items[prepareIndex]);
            setColor(colors[prepareIndex % (colors.length - 1)]);
            if (voice1) {
                voice1(items[prepareIndex]);
            }
            setTimeout(() => {
                setCurrentValue("");
            }, speed)
            prepareIndex++;
        }, speed + 100);
        return interval;
    }

    const exerciseTimeout = (items, speed, voice1) => {
        if (prepareIndex < items.length) {
            setTimeout(() => {
                setCurrentValue("");
            }, speed)
            setCurrentValue(items[prepareIndex]);
            setColor(colors[prepareIndex % (colors.length - 1)]);
            if (voice1) {
                voice1(items[prepareIndex]);
            }

            setTimeout(() => {
                exerciseTimeout(items, speed, voice1)
            }, speed + 100)
        } else {
            setPhase(PHASE_ANSWER)
        }
        prepareIndex++;
    }

    useEffect(() => {
        if (phase === PHASE_PREPARE) {
            setIntervalIdPrepare(
                createInterval(
                    [getNameByValue(solveTypes, task.setting.solveType), ...prepare],
                    PHASE_EXERCISE,
                    1000));
        }
        if (phase === PHASE_EXERCISE) {
            const {complexity, speed} = task.setting;
            const isSpeak = (complexity, speed) => {
                if (complexity === 1) return speed >= 0.9
                if (complexity === 10) return speed >= 1.2
                if (complexity === 100) return speed >= 2
                return false;
            }
            setTimeoutId(setTimeout(() => {
                exerciseTimeout(task.values,
                    speed * 1000,
                    isSpeak(complexity, speed) && voice)
            }, 1200))
        }
        if (phase === PHASE_ANSWER) {
            setCurrentValue("Ответ?")
        }
        if (phase === PHASE_RESULT) {
            if (!answer) {
                if (window.history.state && window.history.state.idx > 0) {
                    navigate(-1);
                } else {
                    navigate('/home', {replace: true}); // the current entry in the history stack will be replaced with the new one with { replace: true }
                }
            }
            if (parseInt(myAnswer) === parseInt(answer.rightAnswer)) {
                setCurrentValue("Верно");
                setColor(green);
            } else {
                setCurrentValue("Не верно");
                setColor(red);
            }
        }
    }, [phase])
    useEffect(() => {
        return () => {
            clearInterval(intervalIdPrepare)
            clearTimeout(timeoutId)
        }
    }, [intervalIdPrepare])

    const getStyle = () => {
        const result = {
            color: color
        }

        if (taskType !== ORDINARY && phase === PHASE_EXERCISE) {
            const x = Math.floor(Math.random() * 11);
            const y = Math.floor(Math.random() * 11);
            result.gridColumn = x;
            result.gridRow = y;

            if (taskType === TURBO_PLUS) {
                const size = Math.floor(Math.random() * 8);
                result.fontSize = 4 + size + 'vw'
            }
        } else {
            return {
                color: color
            }
        }

        return result;
    }

    return (
        <div className={taskType !== ORDINARY && phase === PHASE_EXERCISE ? "Game-wrapper-turbo" : "Game-wrapper"}>
            <div style={getStyle()} className="Game-value">
                {currentValue}
            </div>
        </div>
    )
}

Game.propTypes = {
    phase: PropTypes.string.isRequired,
    setPhase: PropTypes.func.isRequired,
    myAnswer: PropTypes.string,
    taskType: PropTypes.string.isRequired,
}